
  import React from "react"
  import Component from "/Users/vladyslav/www/starter-gatsby-blog/src/layouts/index.js"
  import data from "/Users/vladyslav/www/starter-gatsby-blog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js